import { useIsFoundationalPillarsNavPhase1Enabled } from '@ms/yammer-features-app-navigation';
import {
  useIsAdminCenterEnabled,
  useIsQuestionsOnlyMode,
  useIsStorylineAdminEnabled,
} from '@ms/yammer-web-ui-features/dist/featureChecks';
import { useMainFeatureSettings } from '@ms/yammer-web-ui-features/dist/featureSettings';
import { useIsMobileClient } from 'hooks/selectors';
import { useMemo } from 'react';

type UseAppFeatureSettings = () => ReturnType<typeof useMainFeatureSettings>;
export const useAppFeatureSettings: UseAppFeatureSettings = () => {
  const isAdminCenterEnabled = useIsAdminCenterEnabled();
  const isMobileClient = useIsMobileClient();
  const isQuestionsOnlyMode = useIsQuestionsOnlyMode();
  const isStorylineAdminEnabled = useIsStorylineAdminEnabled();
  const isFoundationalPillarsNavPhase1Enabled = useIsFoundationalPillarsNavPhase1Enabled();

  const uiFeatureOptions = useMemo<Parameters<typeof useMainFeatureSettings>[0]>(
    () => ({
      overrides: {
        navigation: {
          admin: isAdminCenterEnabled,
          collapsiblePanel: !isQuestionsOnlyMode,
          leftSidebar: isFoundationalPillarsNavPhase1Enabled,
          networks: !isMobileClient,
          settings: !isMobileClient,
          storylinesAdmin: !isQuestionsOnlyMode && !isAdminCenterEnabled && isStorylineAdminEnabled,
        },
        threadPage: {
          groupsExplorerCard: !isQuestionsOnlyMode,
        },
      },
    }),
    [
      isAdminCenterEnabled,
      isMobileClient,
      isQuestionsOnlyMode,
      isStorylineAdminEnabled,
      isFoundationalPillarsNavPhase1Enabled,
    ]
  );

  return useMainFeatureSettings(uiFeatureOptions);
};
